import React from "react";
import fastAndEasyIcon from "assets/products/shared/icons/fast-and-easy.svg";
import instantCoverageIcon from "assets/products/shared/icons/instant-coverage.svg";
import acceleratedDeathBenefitIcon from "assets/products/shared/icons/accelerated-death-benefit.svg";
import reliableCoverageIcon from "assets/products/shared/icons/reliable-coverage.svg";
import convertibleIcon from "assets/products/shared/icons/convertible.svg";
import spouseCoverageIcon from "assets/products/shared/icons/spouse-coverage.svg";

interface DirectTermLifeInsuranceProps {
    className?: string;
}

const DirectTermLifeInsurance = ({ className = "" }: DirectTermLifeInsuranceProps) => {
    const features = [
        {
            image: fastAndEasyIcon,
            title: "Fast & Easy Application",
            description: "No medical exams—just three health questions.",
        },
        {
            image: instantCoverageIcon,
            title: "Instant Coverage",
            description: "Once approved and your first payment is processed, you're covered immediately.",
        },
        {
            image: acceleratedDeathBenefitIcon,
            title: "Accelerated Death Benefit",
            description:
                "You could receive up to 50% of the total benefit in advance if diagnosed with a terminal illness that will result in death in 12 months or less (Availability and time period varies by state).",
        },
        {
            image: reliableCoverageIcon,
            title: "Flexible & Reliable",
            description: "Renewable through age 80 - with age-based rates. No in person medical medical exam is required.",
        },
        {
            image: convertibleIcon,
            title: "Convertible to Permanent",
            description: "Convert to lifelong coverage before age 65—no new medical exam required.",
        },
        {
            image: spouseCoverageIcon,
            title: "Spouse¹ Coverage Option",
            description: "Add coverage for your spouse at exclusive member-only rates.",
        },
    ];

    return (
        <div className={`w-full py-16 px-6 bg-neutral ${className}`}>
            <div className="max-w-[1200px] mx-auto">
                <div className="text-center mb-12">
                    <div className="text-base-content text-2xl font-bold mb-2 hidden tablet:block">
                        Direct Term Life Insurance
                    </div>
                    <h2 className="tablet:text-5xl text-3xl tablet:font-normal font-bold text-base-content">
                        Easy, Reliable Coverage
                    </h2>
                </div>
                <div className="grid tablet:grid-cols-3 grid-cols-2 gap-8">
                    {features.map((feature, index) => (
                        <div key={index} className="text-center">
                            <div className="flex tablet:justify-center justify-start mb-4">
                                <img src={feature.image} alt="" className="tablet:w-20 tablet:h-20 w-12 h-12 object-contain" />
                            </div>
                            <h3 className="tablet:text-2xl text-xl font-bold text-base-content mb-2 tablet:text-center text-left">
                                {feature.title}
                            </h3>
                            <p className="text-base-content text-base font-medium leading-relaxed tablet:text-center text-left">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DirectTermLifeInsurance;
